export default __webpack_public_path__ + "static/media/chapter8.39617e04.svg";